import React, { useState } from "react";
import { TableUi } from "./../../ui/TableUi";
import { ButtonUi } from "../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../types/typesConstants";
import {
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  FilePdfOutlined,
  FileSearchOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import { Button, Dropdown, Tag } from "antd";
import { useDispatch } from "react-redux";
import {
  comprobantecompraSetActive,
  comprobantecompraStartDelete,
  comprobantecompraStartLoad,
  showFormComprobanteCompra,
} from "../../../actions/compra";
import { download_FileObject } from "../../../helpers/utils";
import { ItemDetallePreviewModal } from "../modal/ItemDetallePreviewModal";
import { showDeleteConfirm } from "../../../helpers/confirmModal";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { comprobanteMovimientoSetActive } from "../../../actions/inventario";
import { NroComprobanteColumn } from "../../ui";

const handleMenuOpt = (e, record, acciones) => {
  const {
    handleEditar,
    handleMovimientoEntrada,
    handleEliminar,
    handlePrintPDF,
  } = acciones;

  switch (e.key) {
    case "pdfcomprobantecompra":
      handlePrintPDF(record);
      break;
    case "editar":
      handleEditar(record);
      break;
    case "eliminar":
      handleEliminar(record);
      break;
    case "copiarmovimiento":
      handleMovimientoEntrada(record);
      break;
    default:
      break;
  }
};

const items = (data) => {
  const _exist_item_inventario =
    data?.detallescomprobantecompra?.some((x) => x.esinventariado === true) &&
    !data?.comprobantemovimiento;

  let itemsMenu = [
    {
      key: "pdfcomprobantecompra",
      label: "Imprimir",
      icon: <FilePdfOutlined />,
    },
    {
      key: "editar",
      label: "Editar",
      icon: <EditOutlined />,
    },
    {
      key: "eliminar",
      label: "Eliminar",
      icon: <DeleteOutlined />,
    },
  ];
  if (_exist_item_inventario) {
    itemsMenu = [
      {
        key: "copiarmovimiento",
        label: "Crear mov. inventario",
        icon: <CopyOutlined />,
      },
      ...itemsMenu,
    ];
  }
  return itemsMenu;
};

const menuProps = (record, acciones) => ({
  items: items(record),
  onClick: (e) => handleMenuOpt(e, record, acciones),
});

const BtnGroupComprobante = ({ comprobante, acciones }) => {
  return (
    <>
      <Dropdown menu={menuProps(comprobante, acciones)} trigger={["click"]}>
        <Button className="ml-2">
          <MoreOutlined />
        </Button>
      </Dropdown>
    </>
  );
};

const columns = (acciones) => {
  const { handleShowItems } = acciones;

  return [
    {
      title: "#",
      dataIndex: "nro",
      key: "nro",
      render: (text, record, index) => <>{index + 1}</>,
    },
    {
      title: "Fecha Emisión",
      dataIndex: "fechaemision",
      key: "fechaemision",
    },
    {
      title: "Fecha Vencimiento",
      dataIndex: "fechavencimiento",
      key: "fechavencimiento",
    },
    {
      title: "Proveedor",
      dataIndex: "proveedor_nombre",
      key: "proveedor_nombre",
    },
    {
      title: "Comprobante",
      dataIndex: "nrocomprobante",
      key: "nrocomprobante",
      render: (text, record) => (
        <NroComprobanteColumn
          nrocomprobante={record?.nrocomprobante}
          tipocomprobante_nombre={record?.tipocomprobante_nombre}
        />
      ),
      align: "center",
    },
    {
      title: "Forma pago",
      dataIndex: "formapago_nombre",
      key: "formapago_nombre",
      align: "center",
    },

    {
      title: "Productos",
      dataIndex: "btnproductos",
      key: "btnproductos",
      render: (text, record) => (
        <ButtonUi
          typeUi={TipoButtonConstants.CustomButton}
          icon={<FileSearchOutlined />}
          displayText={false}
          onClick={() => handleShowItems(record)}
        />
      ),
      align: "center",
    },
    {
      title: "¿Tiene Detracción?",
      dataIndex: "tienedetraccion",
      key: "tienedetraccion",
      align: "center",
      render: (text, record) => (
        <>
          {text ? (
            <>
              <Tag color="success">
                <b>SI</b>
              </Tag>
              <br />
              <sub>
                <b>S/{record?.montodetraccion}</b>
              </sub>
            </>
          ) : (
            <Tag color="default">
              <b>NO</b>
            </Tag>
          )}
        </>
      ),
    },
    {
      title: "Total",
      dataIndex: "montototal",
      key: "montototal",
      align: "right",
      render: (text, record) => (
        <>
          <b>{record?.monedaprefijo} </b>
          {parseFloat(text).toFixed(2)}
        </>
      ),
    },
    {
      title: "",
      dataIndex: "opciones",
      key: "opciones",
      render: (text, record) => (
        <BtnGroupComprobante comprobante={record} acciones={acciones} />
      ),
    },
  ];
};

export const ComprobanteCompraTable = ({
  comprobantes,
  loading,
  paginator,
}) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const showModal = () => setOpen(true);
  const hideModal = () => setOpen(false);
  const handleEditar = (data) => {
    dispatch(comprobantecompraSetActive(data));
    dispatch(showFormComprobanteCompra());
  };
  const handleEliminar = (data) => {
    showDeleteConfirm(
      "¿Está seguro de eliminar el comprobante seleccionado?",
      `${data.nrocomprobante}`,
      (isConfirmed) => {
        if (isConfirmed) {
          dispatch(comprobantecompraStartDelete(data));
        }
      }
    );
  };
  const handlePrintPDF = async (comprobante) => {
    let name_file = `${comprobante?.proveedor_nrodocumento}-${comprobante?.nrocomprobante}`;
    download_FileObject(comprobante?.archivo, name_file);
  };
  const handleShowItems = (data) => {
    setItems(data?.detallescomprobantecompra);
    showModal();
  };
  const handleMovimientoEntrada = (data) => {
    localStorage.setItem("ComprobanteCompraForm", true);
    const valueData = {
      id: null,
      comprobantecompra: data?.id,
      detallescomprobantemovimiento: data?.detallescomprobantecompra?.map(
        (x, index) => ({
          id: dayjs().valueOf() + index,
          item: x.item,
          item_nombre: x.item_nombre,
          unidadmedida: x.unidadmedida,
          unidadmedida_nombre: x.unidadmedida_nombre,
          cantidad: parseFloat(x.cantidad),
          manejalotes: x.manejalotes,
          manejaseries: x.manejaseries,
          esinventariado: x.esinventariado,
          costo: parseFloat(x.preciounitario),
          moneda: data.moneda,
        })
      ),
    };
    dispatch(comprobanteMovimientoSetActive(valueData));
    return navigate("/inventario/movimientoentrada", { replace: true });
  };
  const handleLoadDataPagination = (page = 1, page_size = 10) => {
    let searchFormData = JSON.parse(localStorage.getItem("SearhFormTable"));
    searchFormData = { ...searchFormData, page, page_size };
    const paginates = Math.floor(paginator?.count / page_size);
    if (paginates >= 1) {
      dispatch(comprobantecompraStartLoad(searchFormData));
    }
  };
  return (
    <>
      <TableUi
        data={comprobantes}
        columns={columns({
          handleEditar,
          handleEliminar,
          handleMovimientoEntrada,
          handleShowItems,
          handlePrintPDF,
        })}
        rowKey="id"
        size="small"
        loading={loading}
        pagination={{
          align: "start",
          showSizeChanger: true,
          total: paginator?.count,
          onChange: (page, page_size) =>
            handleLoadDataPagination(page, page_size),
          showTotal: (total) => `Total ${total} items`,
        }}
      />
      <ItemDetallePreviewModal items={items} open={open} onCancel={hideModal} />
    </>
  );
};
